export enum ActionsEnum {
  ACTION_STARTED = 'ACTION_STARTED',
  ACTION_ENDED = 'ACTION_ENDED',
  ACTION_ENDED_WITH_ERRORS = 'ACTION_ENDED_WITH_ERRORS',
}
